export default __webpack_public_path__ + "static/media/bad-1.54c1793e.png";